<template>
  <v-layout>
    <template v-for="(n, i) of 4">
      <v-flex md3  :key="i" :class="fotos[n-1] !== undefined ? 'text-xs-center pa-2 outerDiv' : 'text-xs-center pa-2 outerDiv'">
        <div v-if="fotos[n-1] !== undefined" class="outerDiv">
          <img :src="fotos[n-1]" alt="" class="img-responsive">
        </div>
          <template v-else lang="html">
            <input class="invisible-all" type="file" name="" value="" v-on:change="adicionarFoto">
            <div class="outerDiv">
              <div class="pa-2 noselect foto">
                <v-icon>insert_photo</v-icon>
                adicionar foto
              </div>
            </div>
          </template>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
export default {
  name: 'galeria',
  methods: {
    adicionarFoto (elem) {
      this.$store.dispatch('uploadImages', elem.target.files[0])
    },
    removerFoto (elem) {
      this.$store.dispatch('deleteImages', 'url')
    }
  },
  computed: {
    fotos () {
      return this.$store.getters.itemSelecionado.fotos
    }
  }
}
</script>
<style>
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.foto{
  position: relative;
}
.foto i{
  display: block;
}
.invisible-all{
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  width: 100%;
  max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// Galeria.vue?8f5b3a08